import { Navigate } from "react-router-dom";
import * as React from "react";
import { useSelector } from "react-redux";
import { isAuthenticatedSelector } from "../redux/slice/selectors";
import PATH from "../paths";

export function RequireAuth({ children }: { children: any }) {
  const isAuthenticated = useSelector(isAuthenticatedSelector);

  if (!isAuthenticated) {
    return <Navigate to={PATH.LOGIN} />;
  }

  return children;
}
